"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EditorialNarrative() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}